
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ProductWiseSalesApi } from '../api/product-wise-sales.api';
import { switchMap, map } from 'rxjs/operators';
import { ProductWiseSalesData, ProductWiseSales } from '../../../interfaces/masters/product-wise-sales';

@Injectable()
export class ProductWiseSalesService extends ProductWiseSalesData {

  constructor(private api: ProductWiseSalesApi) {
    super();
  }



  list(url: string): Observable<ProductWiseSales[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ProductWiseSales>{
      return this.api.getById(url);
  }

  create(url: string, data:ProductWiseSales): Observable<ProductWiseSales> {
    return this.api.add(url,data);
  }

  update(url: string, data:ProductWiseSales): Observable<ProductWiseSales> {
    return this.api.update(url,data);
  }
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }


  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
